/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import { Switch } from 'react-router';
import CustomRoute from 'components/custom-route';
import BndesWelcome from 'containers/direto/bndes-welcome/bndes-welcome';
import PreApprovedHome from 'containers/pre-approved/home/pre-approved-home';
import { getRouterOrder, getPreApprovedCustomRoutes } from './configs/routes';
import PreQualifiedNotFound from 'containers/pre-approved/pre-qualified-not-found/pre-qualified-not-found';
import ErrorWithButtonPage from 'containers/errorWithButton';
import PartnerSummary from 'containers/partner-summary/partner-summary';

const AppRoutes: React.FC = () => {

    const customProductsRoutes = [
        {
            path: '/bndes',
            component: BndesWelcome
        },
        {
            path: '/bndes/:loanApplicationId',
            component: BndesWelcome
        },
        {
            path: '/pre-aprovado',
            component: PreApprovedHome
        },
        {
            path: '/nao-encontrado',
            component: PreQualifiedNotFound
        },
        {
            path: '/generic-error',
            component: ErrorWithButtonPage
        },
        {
            path: '/:loanApplicationId/financiamento',
            component: PartnerSummary
        }
    ]

    return (
        <Switch>
            {
                customProductsRoutes.map(({ path, component }, key: number) => (
                    <CustomRoute key={key} path={path} component={component} />
                ))
            },
            {
                [...getPreApprovedCustomRoutes(), ...getRouterOrder()].map(({ step, ...props }, key: number) => (
                    <CustomRoute key={key} {...props} />
                ))
            }
        </Switch>
    )
}

export default AppRoutes;
